module.exports = __webpack_public_path__ + "img/band-dark.6d82fd1d.svg";